export class UserEmailConstants {
  public static readonly ERIC_STEPHEN_MAAS_GMAIL: string = 'eric.stephen.maas@gmail.com';
  public static readonly JEREMYRGUNN_GMAIL: string = 'jeremyrgunn@gmail.com';
  public static readonly JON_R_OLER_GMAIL: string = 'jonroler@gmail.com';
  public static readonly JON_R_OLER_2_GMAIL: string = 'joncharoler@gmail.com';
  public static readonly BJORN_ESPENES_GMAIL: string = 'bjorn.espenes@gmail.com';
  public static readonly EMGAPPS_AI: string = '@emgapps.ai';
  public static readonly SYMPHIQ_COM: string = '@symphiq.com';
  public static readonly ERIC_EMGAPPS_AI: string = 'eric@emgapps.ai';
  public static readonly ERIC_SYMPHIQ_COM: string = 'eric@symphiq.com';
  public static readonly JEREMY_EMGAPPS_AI: string = 'jeremy@emgapps.ai';
}
